var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 280,
    viewBox: "0 0 116.42 74.083",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -222.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 -100.73 153.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#5d6ad8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-133.11 -43.292)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0335 0 0 2.0335 89.03 200.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2h-8c-1.1 0-1.99 0.9-1.99 2l-0.01 16c0 1.1 0.89 2 1.99 2h12.01c1.1 0 2-0.9 2-2v-12zm2 16h-8v-2h8zm0-4h-8v-2h8zm-3-5v-5.5l5.5 5.5z",
    fill: "#5d6ad8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.078 0 0 1.078 115.74 180.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.35 10.04c-0.68-3.45-3.71-6.04-7.35-6.04-2.89 0-5.4 1.64-6.65 4.04-3.01 0.32-5.35 2.87-5.35 5.96 0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-5.35 2.96v4h-4v-4h-3l5-5 5 5z",
    fill: "#868fe2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuSub);
export default __webpack_public_path__ + "static/media/stu-sub.c65934e840efcd8cf62c7af503f30bbf.svg";
export { ForwardRef as ReactComponent };